import React, { Component } from 'react';
import AdminPage from './AdminPage';
import ReservationList from '../components/ReservationList';
import ReservationForm from '../components/ReservationForm';
import ClientForm from '../components/ClientForm';
import $ from 'jquery'; 
import VenueStatsBar from '../components/VenueStatsBar';
import {firebaseDb} from '../lib/firebase/firebase';
import {
  timePassedSince,
} from '../utils/lib';
import { 
  Modal,
} from 'react-bootstrap/lib';
var Sound = require('react-sound').default;
class IndicatorIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  componentDidMount(){
  }
  componentWillUnmount(){
  }
  render(){
    return (
      <div className="panel panel-default" style={{height:132,}}>
        <div className="panel-body text-left">
          <h1 style={{marginTop:11,}}>{this.props.value}</h1>
          <h4 style={{marginTop:11,}}>{this.props.name}</h4>
        </div>
      </div>
    );
  }
}

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeFrame:'MONTH',
    };
  }
  componentDidMount(){
    var _self = this;
    var us = {};
    firebaseDb.ref('admin_stats').on('value',function(snap){
      _self.setState({
        admin_stats: snap.val(),
        loading:false,
      })
    });
  }
  componentWillUnmount(){
  }
  selectTimeFrame(tf){
    this.setState({timeFrame:tf})
  }
  getDate(timeframe){
    switch(timeframe){
      case 'TODAY':
        var date = new Date();
        return (new Date(date.getFullYear(), date.getMonth(), date.getDate())).getTime();
        break;
      case 'WEEK':
        var date = new Date();
        var daysFromSunday = date.getDay();
        return (new Date(date.getFullYear(), date.getMonth(), date.getDate() - daysFromSunday)).getTime();
        break;
      case 'MONTH':
        var date = new Date();
        return (new Date(date.getFullYear(), date.getMonth(), 1)).getTime();
        break;
      case 'YEAR':
        var date = new Date();
        return (new Date(date.getFullYear(), 0, 1)).getTime();
        break;
      case 'ALL':
        return 0;
        break;
    }
  }
  getUsersByCountry(){
    var items = [];
    var countries = [];
    var total_users = 0;
    for(var c in this.state.admin_stats.data[this.state.timeFrame].by_countries){
      total_users = total_users + this.state.admin_stats.data[this.state.timeFrame].by_countries[c].new_users;
      countries.push(
        {
          name:c,
          new_users:this.state.admin_stats.data[this.state.timeFrame].by_countries[c].new_users,
        } 
      )
    }
    countries.sort(function(a,b){
      return a.new_users - b.new_users;
    })
    for(var c in countries){
      var bar_size = parseInt(100 * (countries[c].new_users/total_users));
      if(countries[c].new_users!=0){
        items.unshift(
          <div key={c} className="row">
            <div className="col-md-4 col-sm-4 col-xs-6">
              <p>{countries[c].name} {((countries[c].new_users/total_users)*100).toFixed(2)}% ({countries[c].new_users})</p>
            </div>
            <div className="col-md-8 col-sm-8 col-xs-6">
              <div className="progress progress-striped active">
                <div className="progress-bar progress-bar-warning" style={{width:(((bar_size).toFixed(0))+'%')}}></div>
              </div>
            </div>
          </div>
        );
      }
    }
    if(items.length==0){
      items = (
        <div key={c} className="row" style={{marginBottom:15}}>
          <div className="col-md-4 col-sm-4 col-xs-6">
            <p>No data.</p>
          </div>
        </div>
      )
    }
    return items;
  }

  getActivitiesByCountry(){
    var items = [];
    var countries = [];
    var total_activities = 0;
    for(var c in this.state.admin_stats.data[this.state.timeFrame].by_countries){
      total_activities = total_activities + this.state.admin_stats.data[this.state.timeFrame].by_countries[c].activities;
      countries.push(
        {
          name:c,
          activities:this.state.admin_stats.data[this.state.timeFrame].by_countries[c].activities,
        } 
      )
    }
    countries.sort(function(a,b){
      return a.activities - b.activities;
    })
    for(var c in countries){
      var bar_size = parseInt(100 * (countries[c].activities/total_activities));
      if(countries[c].activities!=0){
        items.unshift(
          <div key={c} className="row">
            <div className="col-md-4 col-sm-4 col-xs-6">
              <p>{countries[c].name} {((countries[c].activities/total_activities)*100).toFixed(2)}% ({countries[c].activities})</p>
            </div>
            <div className="col-md-8 col-sm-8 col-xs-6">
              <div className="progress progress-striped active">
                <div className="progress-bar progress-bar-warning" style={{width:(((bar_size).toFixed(0))+'%')}}></div>
              </div>
            </div>
          </div>
        );
      }
    }
    if(items.length==0){
      items = (
        <div key={c} className="row" style={{marginBottom:15}}>
          <div className="col-md-4 col-sm-4 col-xs-6">
            <p>No data.</p>
          </div>
        </div>
      )
    }
    return items;
  }

  render() {
    var stats = this.state.admin_stats && this.state.admin_stats.data && this.state.admin_stats.data[this.state.timeFrame] ? this.state.admin_stats.data[this.state.timeFrame] : null;
    if(stats){
      var users_by_countries = this.getUsersByCountry();
      var activities_by_countries = this.getActivitiesByCountry();
      return (
        <AdminPage
          user={this.props.user}>

          <div className="row" style={{marginBottom:15}}>
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="btn-group btn-group-justified">
                <a href="#" onClick={this.selectTimeFrame.bind(this,"TODAY")} className={"btn btn-sm btn-"+(this.state.timeFrame=='TODAY'?'warning':'default')}>TODAY</a>
                <a href="#" onClick={this.selectTimeFrame.bind(this,"WEEK")} className={"btn btn-sm btn-"+(this.state.timeFrame=='WEEK'?'warning':'default')}>WEEK</a>
                <a href="#" onClick={this.selectTimeFrame.bind(this,"MONTH")} className={"btn btn-sm btn-"+(this.state.timeFrame=='MONTH'?'warning':'default')}>MONTH</a>
                <a href="#" onClick={this.selectTimeFrame.bind(this,"YEAR")} className={"btn btn-sm btn-"+(this.state.timeFrame=='YEAR'?'warning':'default')}>YEAR</a>
                <a href="#" onClick={this.selectTimeFrame.bind(this,"ALL")} className={"btn btn-sm btn-"+(this.state.timeFrame=='ALL'?'warning':'default')}>ALL</a>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-sm-4 col-xs-6">
              <IndicatorIcon 
                icon={"user"}
                name={"NEW USERS"}
                value={stats.new_users}
                />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <IndicatorIcon 
                icon={"user"}
                name={"ACTIVE USERS"}
                value={stats.active_users}
                />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <IndicatorIcon 
                icon={"user"}
                name={"FB USERS"}
                value={stats.facebook_users}
                />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <IndicatorIcon 
                icon={"star"}
                name={"ACTIVITIES"}
                value={stats.activities}
                />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <IndicatorIcon 
                icon={"hand"}
                name={"ACTIVE ACTIVITIES"}
                value={stats.active_activities?stats.active_activities : "0"}
                />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <IndicatorIcon 
                icon={"star"}
                name={"PUBLIC ACTIVITIES"}
                value={(stats.public_activities*100/stats.activities).toFixed(0)+"%"}
                />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <IndicatorIcon 
                icon={"hand"}
                name={"CONFIRMED USERS"}
                value={stats.confirmed_users}
                />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <IndicatorIcon 
                icon={"hand"}
                name={"FILL RATE"}
                value={stats.fill_rate?stats.fill_rate+"%" : "-- %"}
                />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <IndicatorIcon 
                icon={"hand"}
                name={"PLUS RATE"}
                value={stats.plus_rate?stats.plus_rate+"%" : "-- %"}
                />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <IndicatorIcon 
                icon={"cash"}
                name={"AMOUNT SOLD"}
                value={"$"+(stats.paid_amount).toFixed(2)}
                />
            </div>
            <div className="col-md-3 col-sm-4 col-xs-6">
              <IndicatorIcon 
                icon={"card"}
                name={"PAYMENTS"}
                value={stats.pay_activities}
                />
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="panel panel-default">
                <div className="panel-heading text-left">
                  <h2>New Users by Country</h2>
                </div>
                <div className="panel-body text-left">
                  {users_by_countries}
                </div>
              </div>
            </div>
            
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="panel panel-default">
                <div className="panel-heading text-left">
                  <h2>Activities by Country</h2>
                </div>
                <div className="panel-body text-left">
                  {activities_by_countries}
                </div>
              </div>
            </div>
            
          </div>
          <div className="row" style={{marginBottom:15}}>
            <div className="col-md-12 col-sm-12 col-xs-12">
              <p><strong>Last update</strong>: {this.state.admin_stats.last_update_date?(new Date(this.state.admin_stats.last_update_date)).toLocaleString(): "..."}</p>
            </div>
          </div>
        </AdminPage>
      );
    }else{
      return (
        <AdminPage
          user={this.props.user}>

          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="btn-group btn-group-justified">
                <a href="#" onClick={this.selectTimeFrame.bind(this,"TODAY")} className="btn btn-sm btn-default">TODAY</a>
                <a href="#" onClick={this.selectTimeFrame.bind(this,"WEEK")} className="btn btn-sm btn-default">WEEK</a>
                <a href="#" onClick={this.selectTimeFrame.bind(this,"MONTH")} className="btn btn-sm btn-default">MONTH</a>
                <a href="#" onClick={this.selectTimeFrame.bind(this,"YEAR")} className="btn btn-sm btn-default">YEAR</a>
                <a href="#" onClick={this.selectTimeFrame.bind(this,"ALL")} className="btn btn-sm btn-default">ALL</a>
              </div>
            </div>
          </div>

        </AdminPage>
      );
    }
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/Home.js